import { render } from "./DefVideo.vue?vue&type=template&id=0e8c6e17&scoped=true"
import script from "./DefVideo.vue?vue&type=script&lang=js"
export * from "./DefVideo.vue?vue&type=script&lang=js"

import "./DefVideo.vue?vue&type=style&index=0&id=0e8c6e17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8c6e17"]])

export default __exports__